import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

const ScrollToFormError = () => {
  const { errors, submitCount, isSubmitting } = useFormikContext();
  const lastScrolledSubmitCount = useRef(0);

  useEffect(() => {
    const errorKeys = Object.keys(errors);

    if (submitCount > lastScrolledSubmitCount.current && errorKeys.length > 0 && !isSubmitting) {
      lastScrolledSubmitCount.current = submitCount;

      const firstErrorKey = errorKeys[0];
      const element = document.querySelector(`[name="${firstErrorKey}"]`);

      if (element && element.scrollIntoView) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [errors, submitCount, isSubmitting]);

  return null;
};

export { ScrollToFormError };
